/** localStorage flag set by the signup flow (email + Google OAuth paths). When
 *  present, the next visit to an authenticated app route shows a one-time
 *  welcome dialog offering the product tour. Cleared on first interaction
 *  (take / skip / dismiss) so the prompt never re-fires.
 *
 *  Lives in its own module so the signup form and the prompt's lazy gate can
 *  read it without pulling WelcomeTourPrompt (and framer-motion) into their
 *  chunks. This module owns the whole protocol (key, sentinel value, window
 *  guards) so the arming, gating, and clearing call sites can never disagree.
 */
const WELCOME_TOUR_FLAG = 'sharpr.welcome_tour_pending';

export function armWelcomeTour(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(WELCOME_TOUR_FLAG, '1');
}

export function isWelcomeTourPending(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(WELCOME_TOUR_FLAG) === '1';
}

export function clearWelcomeTour(): void {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(WELCOME_TOUR_FLAG);
}
